import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:teamId/participants',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/ParticipantsContainer',
      './modules/participants'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Participants = require('./containers/ParticipantsContainer').default
      const actions = require('./modules/participants')
      const reducer = require('./modules/participants').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'participants', reducer: reducer })

      store.dispatch(actions.fetchData(nextState.params.teamId))

      /*  Return getComponent   */
      cb(null, Participants)

    /* Webpack named bundle   */
    }, 'participants')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Participants/index.js